import BaseComponent from "../../../../base/common/BaseComponent";
import downloadIcon from "../../../../assets/image/downloadIcon.png";
import downloadHoverIcon from "../../../../assets/image/downloadHoverIcon.png";
import { downloadFileByUrl } from "../../../publicDictionaryValues";
import Buttons from "../../../../base/basicComponents/button";
import styles from "../index.module.scss";
import { Progress } from "antd";

export default class BaseApplyForJbSection extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      downloadIcon: downloadIcon,
      downloadBtnDisabled: true,
      downloadNum: 0,
      downloadLoading: false,
      progress: 1,
    };
  }

  /**
   * function about download file
   */
  downloadFile = (fileId: any, value: any) => {
    let fileList = [];
    if (fileId && value) {
      fileList.push({
        fileID: fileId,
        fileName: value,
      });
    } else {
      // @ts-ignore
      const dataList = this.fileTableRef.current.state.data;
      let downloadList = dataList.filter((x: any) => {
        return x.checked === true;
      });
      downloadList.map((data: any, index: any) => {
        const fileID = data.data.find((item: any) => item.name === "fileId").value;
        const fileName = data.data.find((item: any) => item.name === "fileName").value;
        fileList.push({
          fileID,
          fileName,
        });
      });
      // @ts-ignore
      this.fileTableRef.current.updateDataList(dataList);
    }
    this.openDownloadLoading();
    downloadFileByUrl(fileList, () => this.downloadDetailFilesSuccessfully(fileList));
  };

  /**
   * change download button style when mouse enter
   */
  handleDownloadBtnMouseEnter = () => {
    this.setState({
      downloadIcon: downloadHoverIcon,
    });
  };

  /**
   * change download button style when mouse leave
   */
  handleDownloadBtnMouseLeave = () => {
    this.setState({
      downloadIcon: downloadIcon,
    });
  };

  /**
   * undisable download btn
   */
  openDownloadBtn = () => {
    this.setState({ downloadBtnDisabled: false });
  };

  /**
   * disable download btn
   */
  disableDownloadBtn = () => {
    this.setState({ downloadBtnDisabled: true });
  };

  /**
   * control table delete button diabled
   * @param {*} dataList table data
   */
  openOrDisableDownloadButton = (dataList: any) => {
    const checked = dataList.find((x: any) => x.checked === true);
    if (checked === undefined) {
      this.disableDownloadBtn();
    } else {
      this.openDownloadBtn();
    }
  };
  /**
   * function about control table header checked
   * @param {*} lineId current row lineId
   * @returns
   */
  _check = (lineId: any) => {
    // @ts-ignore
    if (this.fileTableRef.current !== null) {
      // @ts-ignore
      const dataList = this.fileTableRef.current.state.data;
      let currentRow =
        dataList !== null &&
        dataList !== undefined &&
        dataList.find((x: any) => x.data.find((y: any) => y.name === "lineId").value === lineId);
      return !!(currentRow !== undefined && currentRow.checked !== undefined && currentRow.checked);
    }
  };

  /**
   * function about control table header checked when chehck each row
   * @param {*} lineId current row lineId
   * @param {*} ele current checkbox
   */
  _onCheck = (lineId: any, ele: any) => {
    const dataList =
      // @ts-ignore
      this.fileTableRef.current !== null &&
      // @ts-ignore
      this.fileTableRef.current.state.data;
    let currentRow = dataList.find(
      (x: any) => x.data.find((y: any) => y.name === "lineId").value === lineId
    );
    const currentRowIndex = dataList.findIndex(
      (x: any) => x.data.find((y: any) => y.name === "lineId").value === lineId
    );

    if (ele.checked) {
      currentRow = { ...currentRow, checked: true };
    } else {
      currentRow = { ...currentRow, checked: false };
    }

    dataList[currentRowIndex] = currentRow;
    this.openOrDisableDownloadButton(dataList);
    // @ts-ignore
    this.fileTableRef.current.updateDataList(dataList);
  };

  /**
   * function about control procedure table header checked
   * @returns
   */
  _headCheck = () => {
    // @ts-ignore
    if (this.fileTableRef === undefined || this.fileTableRef.current === null) {
      return false;
    }
    const dataList =
      // @ts-ignore
      this.fileTableRef !== undefined && this.fileTableRef.current.state.data;
    if (dataList.length === 0) {
      return false;
    }

    let checked = false;
    checked = dataList.find((x: any) => x.checked !== true);
    return checked === undefined;
  };

  /**
   * function about control row's checkbox when check table header checkbox
   * @param {*} ele table header checkbox element
   */
  _headOnCheck = (ele: any) => {
    // @ts-ignore
    const dataList = this.fileTableRef.current.state.data;
    if (ele.checked) {
      for (let index = 0; index < dataList.length; index++) {
        dataList[index] = { ...dataList[index], checked: true };
      }
    } else {
      for (let index = 0; index < dataList.length; index++) {
        dataList[index] = { ...dataList[index], checked: false };
      }
    }
    this.openOrDisableDownloadButton(dataList);
    // @ts-ignore
    this.fileTableRef.current.updateDataList(dataList);
  };

  openDownloadLoading = () => {
    this.setState({
      downloadNum: 0,
      downloadLoading: true,
      progress: 1,
    });
  };

  downloadDetailFilesSuccessfully = (downloadList: any) => {
    const isDownloadDone = this.state.downloadNum + 1 === downloadList.length;
    const downloadProcess = ((this.state.downloadNum + 1) * 100) / downloadList.length;

    if (isDownloadDone) {
      this.setState({
        downloadNum: this.state.downloadNum + 1,
        progress: 100,
      });
      setTimeout(() => {
        this.setState({
          downloadLoading: false,
        });
      }, 1000);
    } else {
      this.setState({
        downloadNum: this.state.downloadNum + 1,
        // @ts-ignore
        progress: parseInt(downloadProcess),
      });
    }
  };

  /**
   * return download button
   */
  handleApplyForJbSectionDownloadButton = (isDownloadDisabled: any) => {
    const { downloadLoading, progress } = this.state;
    return (
      <div className={styles.downloadButtonDiv}>
        <Buttons
          color="black"
          size="middle"
          onMouseEnter={this.handleDownloadBtnMouseEnter}
          onMouseLeave={this.handleDownloadBtnMouseLeave}
          onClick={this.downloadFile}
          disabled={isDownloadDisabled || downloadLoading}
          testid="apply-jb-base-download-btn"
        >
          <div className={downloadLoading ? `${styles.downloadButton}` : ""}>
            {downloadLoading ? (
              <Progress
                type="circle"
                percent={progress}
                width={18}
                className={styles.antProgress}
              />
            ) : (
              <img src={this.state.downloadIcon} alt="Download" className={styles.downloadIcon} />
            )}
            <span>Download</span>
          </div>
        </Buttons>
      </div>
    );
  };
}
